<template>
  <div class="admin-layout" :style="_style" v-if="site?.name">
    <!-- 顶部栏 -->
    <header class="app-header" :class="{ 'app-header--drag': !kandiankeji }">
      <div class="app-header__brand no-drag">
        <div class="app-header__logo">
          <i class="el-icon-s-shop"></i>
        </div>
        <div class="app-header__meta">
          <div class="app-header__title">{{ title }}</div>
          <div class="app-header__version">v{{ version }}</div>
        </div>
      </div>

      <div class="app-header__center no-drag" v-if="!kandiankeji">
        <button class="header-icon-btn" title="折叠菜单" @click="toggle">
          <i :class="show ? 'el-icon-s-fold' : 'el-icon-s-unfold'"></i>
        </button>
        <div class="header-links">
          <button
            class="header-link-btn"
            @click="gohelp('https://www.yuque.com/xiaoxiaoxiao-uxjki/rpok7u/cfio9qnvk455px53')"
          >
            <i class="el-icon-document"></i>
            <span>上货教程及授权</span>
            <i class="el-icon-arrow-right"></i>
          </button>
          <button
            class="header-link-btn header-link-btn--accent"
            @click="gohelp('https://www.yuque.com/xiaoxiaoxiao-uxjki/rpok7u/got5b24x11pyzl25')"
          >
            <i class="el-icon-key"></i>
            <span>微小店授权教程</span>
            <i class="el-icon-arrow-right"></i>
          </button>
          <button class="header-link-btn" @click="goShopConsole">
            <i class="el-icon-data-board"></i>
            <span>返回中控</span>
            <i class="el-icon-arrow-right"></i>
          </button>
        </div>
      </div>

      <div class="app-header__actions no-drag">
        <button class="header-text-btn" title="我要反馈" @click="openFeedback">
          <i class="el-icon-edit-outline"></i>
          <span>我要反馈</span>
        </button>
        <button class="header-text-btn" title="反馈记录" @click="openFeedbackHistory">
          <i class="el-icon-notebook-2"></i>
          <span>反馈记录</span>
        </button>
        <el-tooltip v-if="site && site.custom_qrcode" effect="dark" placement="bottom">
          <button class="header-icon-btn" title="联系客服">
            <i class="el-icon-service"></i>
          </button>
          <div slot="content">
            <div class="text-center mgb10">联系客服</div>
            <img class="qrcode-img" :src="site.custom_qrcode" />
          </div>
        </el-tooltip>
        <el-tooltip v-if="site && site.custom_qrcode2" effect="dark" placement="bottom">
          <button class="header-icon-btn" title="卡密二维码">
            <i class="el-icon-postcard"></i>
          </button>
          <div slot="content">
            <div class="text-center mgb10">卡密二维码</div>
            <img class="qrcode-img" :src="site.custom_qrcode2" />
          </div>
        </el-tooltip>
        <div class="header-user" v-if="user?.userName" title="当前登录账号">
          <i class="el-icon-user"></i>
          <span class="header-user__name">{{ user.userName }}</span>
        </div>
        <div class="header-divider"></div>
        <button class="header-icon-btn" title="退出" @click="logout">
          <i class="el-icon-switch-button"></i>
        </button>
        <button class="header-icon-btn" title="最小化" @click="minWin">
          <i class="el-icon-minus"></i>
        </button>
        <button class="header-icon-btn" title="最大化" @click="maxMinWin">
          <i class="el-icon-full-screen"></i>
        </button>
        <button class="header-icon-btn header-icon-btn--close" title="关闭" @click="close">
          <i class="el-icon-close"></i>
        </button>
      </div>
    </header>

    <!-- 主体 -->
    <div class="app-body">
      <aside class="app-sidebar">
        <LeftMenu v-if="kandiankeji" :menus="menus" :curRouter="curRouter" />
        <LeftMenuV2 v-else ref="menuv2" :menus="menus" :curRouter="curRouter" />
      </aside>
      <main class="app-main">
        <!-- 单一 router-view：靠 include 决定缓存谁。
             旧的双 router-view + v-if 在切到非 keepAlive 页时会拆掉 keep-alive 子树，缓存丢失。 -->
        <keep-alive :include="include">
          <router-view :key="$route.name || $route.path" />
        </keep-alive>
      </main>
    </div>

    <YiKeTuVue @submit="handleTKTSubmit" @cancel="handleTKYCancel"></YiKeTuVue>
    <Notice @done="onNoticeDone" />
    <SalesBoostGuide ref="salesBoostGuide" />
    <ViolationTicketTip />
    <BrandConfusionTip />
    <FeedbackSubmitDialog ref="feedbackDialog" />
    <FeedbackHistoryDialog ref="feedbackHistoryDialog" />
    <transition name="el-fade-in-linear">
      <div v-if="showVersionTip && versionTipMessage" class="client-version-tip">
        <div class="client-version-tip__head">
          <span class="client-version-tip__title">版本提示</span>
          <span class="client-version-tip__close el-icon-close" title="关闭" @click="closeVersionTip"></span>
        </div>
        <div class="client-version-tip__body">{{ versionTipMessage }}</div>
      </div>
    </transition>
  </div>
</template>
<script>
import $product from "@/mixins/product.js";
import Menu from "@/script/menu";
import YiKeTuVue from "@/components/YiKeTu.vue";
import Notice from "@/components/Notice.vue";
import SalesBoostGuide from "@/components/SalesBoostGuide.vue";
import ViolationTicketTip from "@/components/ViolationTicketTip.vue";
import BrandConfusionTip from "@/components/BrandConfusionTip.vue";
import FeedbackSubmitDialog from "@/components/FeedbackSubmitDialog.vue";
import FeedbackHistoryDialog from "@/components/FeedbackHistoryDialog.vue";
import {
  ensureKefuSmartReplyPolling,
  stopKefuSmartReplyPolling,
} from "@/script/kefuSmartReplyBoot";
export default {
  mixins: [$product],
  components: {
    YiKeTuVue,
    Notice,
    SalesBoostGuide,
    ViolationTicketTip,
    BrandConfusionTip,
    FeedbackSubmitDialog,
    FeedbackHistoryDialog,
    TopMenu: () => import("@/components/NavMenu/Top.vue"),
    LeftMenu: () => import("@/components/NavMenu/Left.vue"),
    LeftMenuV2: () => import("@/components/NavMenu/leftv2.vue"),
  },
  data() {
    return {
      show: true,
      title: "",
      version: "",
      curRouter: "",
      menus: [],
      include: [
        "admin_commodity_copy",
        "admin_commodity_copy_list",
        "admin_gongzuoliu",
        "ViolationBatchPage",
        "BatchEditTitlePage",
        "BatchEditShortTitlePage",
        "BatchEditBrandPage",
        "BatchEditAftersalePage",
        "BatchEditCategoryAttrPage",
        "BatchEditFabricMaterialPage",
        "BatchEditFreightTemplatePage",
        "BatchEditOfflineDeletePage",
        "KefuSmartReplyPage",
        "admin_product_selection",
      ],
      showVersionTip: false,
      versionTipMessage: "",
      _versionCheckTimer: null,
      user: null,
    };
  },
  watch: {
    $route: function (to) {
      this.curRouter = to.name || to.query.router;
    },
  },
  computed: {
    site: function () {
      return this.$store.state.site.siteInfo;
    },
    kandiankeji: function () {
      return this.site?.name == "kandiankeji";
    },
    _style: function () {
      const primary = this.kandiankeji ? "#44bd87" : "#409EFF";
      const isGreen = this.kandiankeji;
      return {
        "--primary": primary,
        "--header-bg": isGreen
          ? "linear-gradient(135deg, #2d9f6f 0%, #44bd87 100%)"
          : "linear-gradient(135deg, #2563eb 0%, #409eff 100%)",
        "--sidebar-bg": "#ffffff",
        "--sidebar-border": "#e8eaed",
        "--sidebar-title": "#1f2937",
        "--sidebar-text": "#4b5563",
        "--sidebar-muted": "#9ca3af",
        "--sidebar-hover": "#f3f4f6",
        "--sidebar-active-bg": isGreen ? "#ecfdf5" : "#eff6ff",
        "--sidebar-active-text": primary,
        "--sidebar-icon": isGreen ? "#44bd87" : "#3b82f6",
        "--menu-text-color": "#4b5563",
        "--menu-active-text-color": primary,
      };
    },
  },
  created() {
    this.curRouter = this.$route.name || this.$route.query.router;
    this.menus = Menu.getMenu(this.site.name);
    this.initPage();
  },
  mounted() {
    this.scheduleVersionCheck();
  },
  beforeDestroy() {
    if (this._versionCheckTimer) {
      clearTimeout(this._versionCheckTimer);
      this._versionCheckTimer = null;
    }
  },
  methods: {
    onNoticeDone() {
      this.$nextTick(() => {
        this.$refs.salesBoostGuide && this.$refs.salesBoostGuide.tryShow();
      });
    },
    gohelp: function (url) {
      this.$call.openBrowse(url);
    },
    goShopConsole() {
      if (this.$route.name === "admin_shop_console") {
        return;
      }
      this.$router.push({ name: "admin_shop_console" });
    },
    openFeedback() {
      this.$refs.feedbackDialog && this.$refs.feedbackDialog.open();
    },
    openFeedbackHistory() {
      this.$refs.feedbackHistoryDialog && this.$refs.feedbackHistoryDialog.open();
    },
    maxMinWin: function () {
      this.$call.sendSync("winEvent.maxMinWin");
    },
    initPage: async function () {
      this.title = await this.$call.invoke("systemEvent.getTitle");
      this.version = await this.$call.invoke("winEvent.getVersion");
      this.user = this.$api.getUserInfo() || null;
      if (!this.site?.name) {
        let res = await this.$call.invoke("systemEvent.getSite");
        this.$store.commit("site/SET_SITE_INFO", res);
      }
      // 进入后台即启动智能客服轮询（不依赖停留在「智能回复」页）
      // 尽快上线，避免 shopN=0 空窗导致买家端「客服不在线」
      setTimeout(() => {
        ensureKefuSmartReplyPolling().catch(() => {});
      }, 300);
    },
    toggle: function () {
      this.$refs.menuv2.toggle();
      this.show = !this.show;
    },
    close: function () {
      this.$call.sendSync("winEvent.closeWin");
    },
    minWin: function () {
      this.$call.sendSync("winEvent.minWin");
    },
    logout: function () {
      stopKefuSmartReplyPolling().catch(() => {});
      this.$call.sendSync("session.delUser");
      this.$router.push({ name: "front_login" });
    },
    handleTKTSubmit(result) {
      this.$store.dispatch("ykt/submit", result);
    },
    handleTKYCancel() {
      this.$store.dispatch("ykt/cancel");
    },
    scheduleVersionCheck() {
      const minMs = 3 * 60 * 1000;
      const maxMs = 5 * 60 * 1000;
      const delay = minMs + Math.random() * (maxMs - minMs);
      this._versionCheckTimer = setTimeout(async () => {
        await this.checkClientVersion();
        this.scheduleVersionCheck();
      }, delay);
    },
    async checkClientVersion() {
      try {
        const res = await this.$api.post(
          "/admintooltaobaoaccount/checkclientversionv2",
          {}
        );
        if (res && res.code === 0 && res.err) {
          this.versionTipMessage = res.err;
          this.showVersionTip = true;
        }
      } catch (e) {
        console.warn("checkclientversionv2", e);
      }
    },
    closeVersionTip() {
      this.showVersionTip = false;
    },
  },
};
</script>
<style scoped>
.admin-layout {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f0f2f5;
}

/* ===== 顶部栏 ===== */
.app-header {
  height: 56px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 0 12px 0 0;
  background: var(--header-bg);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
  position: relative;
  z-index: 100;
}

.app-header--drag {
  -webkit-app-region: drag;
}

.no-drag {
  -webkit-app-region: no-drag;
}

.app-header__brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 20px;
  min-width: 200px;
  flex-shrink: 0;
}

.app-header__logo {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
}

.app-header__meta {
  color: #fff;
}

.app-header__title {
  font-size: 15px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: 0.3px;
}

.app-header__version {
  font-size: 11px;
  opacity: 0.75;
  margin-top: 1px;
}

.app-header__center {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  padding-left: 8px;
}

.header-links {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-link-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  white-space: nowrap;
}

.header-link-btn:hover {
  background: rgba(255, 255, 255, 0.22);
  border-color: rgba(255, 255, 255, 0.55);
}

.header-link-btn--accent {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
}

.header-link-btn i:last-child {
  font-size: 11px;
  opacity: 0.7;
}

.app-header__actions {
  display: flex;
  align-items: center;
  gap: 2px;
  padding-right: 8px;
}

.header-text-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 30px;
  padding: 0 10px;
  margin-right: 4px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, border-color 0.15s;
}

.header-text-btn:hover {
  background: rgba(255, 255, 255, 0.26);
  border-color: rgba(255, 255, 255, 0.55);
}

.header-text-btn i {
  font-size: 14px;
}

.header-icon-btn {
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: rgba(255, 255, 255, 0.88);
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, color 0.15s;
}

.header-icon-btn:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
}

.header-icon-btn--close:hover {
  background: #ef4444;
  color: #fff;
}

.header-user {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 10px;
  color: rgba(255, 255, 255, 0.92);
  font-size: 12px;
  max-width: 180px;
}

.header-user__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.header-divider {
  width: 1px;
  height: 20px;
  background: rgba(255, 255, 255, 0.25);
  margin: 0 6px;
}

.qrcode-img {
  max-width: 400px;
  max-height: 400px;
}

/* ===== 主体 ===== */
.app-body {
  flex: 1;
  display: flex;
  overflow: hidden;
  min-height: 0;
}

.app-sidebar {
  flex-shrink: 0;
  height: 100%;
  overflow: hidden;
  border-right: 1px solid var(--sidebar-border, #e8eaed);
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.04);
}

.app-main {
  flex: 1;
  min-width: 0;
  height: 100%;
  overflow: auto;
  scrollbar-gutter: stable;
  background: #f0f2f5;
  scrollbar-width: thin;
  scrollbar-color: rgba(148, 163, 184, 0.55) transparent;
}

.app-main::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.app-main::-webkit-scrollbar-track {
  background: transparent;
}

.app-main::-webkit-scrollbar-thumb {
  background-color: rgba(148, 163, 184, 0.45);
  border-radius: 999px;
  border: 1px solid transparent;
  background-clip: padding-box;
  transition: background-color 0.2s ease;
}

.app-main::-webkit-scrollbar-thumb:hover {
  background-color: rgba(100, 116, 139, 0.72);
}

.app-main::-webkit-scrollbar-corner {
  background: transparent;
}

.app-main ::v-deep > div {
  height: 100% !important;
  padding: 16px 20px;
  box-sizing: border-box;
  min-height: 0;
}

/* ===== 版本提示 ===== */
.client-version-tip {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 5000;
  max-width: 360px;
  padding: 12px 14px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.15);
  border-left: 4px solid var(--primary, #409eff);
}

.client-version-tip__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.client-version-tip__title {
  font-weight: 600;
  font-size: 16px;
  color: #303133;
}

.client-version-tip__close {
  cursor: pointer;
  font-size: 16px;
  color: #909399;
  padding: 2px;
  line-height: 1;
}

.client-version-tip__close:hover {
  color: #606266;
}

.client-version-tip__body {
  font-size: 14px;
  color: #606266;
  line-height: 1.5;
  word-break: break-word;
  white-space: pre-wrap;
}
</style>
